import { useState, type FormEvent } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { GoogleAuthProvider, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { auth } from '@/firebase';
import { useAuth } from '@/auth/AuthProvider';
import { Buton, Etikete, Gabim, Hyrje, Njoftim } from '@/components/ui';

export function mesazhGabimiAuth(e: unknown): string {
  const kodi = (e as { code?: string })?.code ?? '';
  const m: Record<string, string> = {
    'auth/invalid-credential': 'Email-i ose fjalëkalimi nuk është i saktë.',
    'auth/invalid-email': 'Email-i nuk është i vlefshëm.',
    'auth/user-disabled': 'Kjo llogari është çaktivizuar.',
    'auth/too-many-requests': 'Shumë përpjekje. Provoni pas pak minutash.',
    'auth/email-already-in-use': 'Ky email është i regjistruar tashmë.',
    'auth/weak-password': 'Fjalëkalimi duhet të ketë të paktën 8 karaktere.',
    'auth/popup-closed-by-user': 'Dritarja e Google u mbyll.',
    'auth/network-request-failed': 'Nuk ka lidhje me internetin.',
  };
  return m[kodi] ?? 'Ndodhi një gabim. Provoni sërish.';
}

export default function HyrjaFaqe() {
  const { perdoruesi, roli, ngarkohet } = useAuth();
  const vendi = useLocation() as { state?: { nga?: string } };
  const [email, setEmail] = useState('');
  const [fjalekalimi, setFjalekalimi] = useState('');
  const [gabim, setGabim] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);
  const [duke, setDuke] = useState(false);

  if (!ngarkohet && perdoruesi) return <Navigate to={roli ? vendi.state?.nga ?? '/paneli' : '/ne-pritje'} replace />;

  async function hyr(e: FormEvent) {
    e.preventDefault();
    setGabim(null);
    setDuke(true);
    try {
      await signInWithEmailAndPassword(auth, email.trim(), fjalekalimi);
    } catch (err) {
      setGabim(mesazhGabimiAuth(err));
    } finally {
      setDuke(false);
    }
  }

  async function meGoogle() {
    setGabim(null);
    try {
      await signInWithPopup(auth, new GoogleAuthProvider());
    } catch (err) {
      setGabim(mesazhGabimiAuth(err));
    }
  }

  async function rivendos() {
    if (!email) return setGabim('Shkruani email-in për të rivendosur fjalëkalimin.');
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setInfo('Ju dërguam një email për rivendosjen e fjalëkalimit.');
    } catch (err) {
      setGabim(mesazhGabimiAuth(err));
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center text-center">
          <img src="/logo.png" alt="ALBMEDTECH — Albanian Medical Technology" className="h-28 w-28" />
          <p className="mt-3 text-lg font-semibold tracking-wide">ALBMEDTECH</p>
          <p className="text-xs text-slate-500">Portali i menaxhimit të shërbimeve</p>
        </div>
        <form onSubmit={hyr} className="space-y-4 rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
          <h1 className="text-xl">Hyrje</h1>
          {gabim && <Gabim>{gabim}</Gabim>}
          {info && <Njoftim>{info}</Njoftim>}
          <div>
            <Etikete htmlFor="email">Email</Etikete>
            <Hyrje id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <Etikete htmlFor="fjalekalimi">Fjalëkalimi</Etikete>
            <Hyrje id="fjalekalimi" type="password" autoComplete="current-password" required value={fjalekalimi} onChange={(e) => setFjalekalimi(e.target.value)} />
          </div>
          <Buton type="submit" className="w-full" ngarkohet={duke}>
            Hyr
          </Buton>
          <Buton type="button" varianti="dytesor" className="w-full" onClick={() => void meGoogle()}>
            Hyr me Google
          </Buton>
          <div className="flex justify-between text-sm">
            <button type="button" onClick={() => void rivendos()} className="text-slate-500 hover:text-slate-800">
              Harruat fjalëkalimin?
            </button>
            <Link to="/regjistrohu" className="font-medium text-marka-600 hover:text-marka-700">
              Regjistro institucionin
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
